import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import cn from 'classnames'
import { useDispatch, useSelector } from 'react-redux'

import SideNavigation from '@/ui/components/Header/SideNavigation/SideNavigation'
import {
    MinimalHeader,
} from '@bosch/react-frok'
import { CustomMinimalHeaderProps } from './types/CustomMinimalHeaderTypes'
import { setIsNavOpen } from '@/utils/store/features/application/applicationSlice'
import { RootState } from '@/utils/store/store'
import { useSideNavMenu } from '@/contexts/sideNavContext'

import './CustomMinimalHeader.scss'

const CustomMinimalHeader = ({
    className,
    quickLinks,
    pageName,
}: CustomMinimalHeaderProps) => {
    const dispatch = useDispatch()
    const isNavOpen = useSelector((state: RootState) => state.application.isNavOpen) ?? false
    const { menuGroups } = useSideNavMenu()
    const classNames = cn('custom-minimal-header', className, {
        '--nav-open': isNavOpen,
        '--nav-closed': !isNavOpen,
    })

    const toggleNav = (open?: boolean) => dispatch(setIsNavOpen(open ?? !isNavOpen))

    // Rendered inside MinimalHeader for mobile/tablet overlay (hidden on desktop via CSS).
    // Required so FROK renders the burger button on all viewport sizes.
    const sideNavigation = menuGroups
        ? <SideNavigation menuGroups={menuGroups} isMenuOpen={isNavOpen} toggleMenu={toggleNav} />
        : null

    const getActions = (): ReactNode | undefined => {
        if (!quickLinks?.length) return undefined
        return (
            <>
                {quickLinks.map((link, idx) => (
                    <li key={idx} role='none'>{link.children}</li>
                ))}
            </>
        )
    }

    return (
        <MinimalHeader
            className={classNames}
            sideNavigation={sideNavigation}
            actions={getActions()}
            logo={{ as: Link }}
            burger={{
                onClick: () => toggleNav(),
            }}
        >
            {pageName && pageName}
        </MinimalHeader>
    )
}

export default CustomMinimalHeader
